// extracted by mini-css-extract-plugin
export default {"mainContainer":"udemyResearch_mainContainer__UrBNw","leftSubContainer":"udemyResearch_leftSubContainer__rKvD4","rightSubContainer":"udemyResearch_rightSubContainer__RtBYV"};